"use strict";

exports.__esModule = true;
exports.default = chain;
var _underscore = _interopRequireDefault(require("./underscore.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Start chaining a wrapped Underscore object.
function chain(obj) {
  var instance = (0, _underscore.default)(obj);
  instance._chain = true;
  return instance;
}